import { render } from "./HistoryEvent.vue?vue&type=template&id=6304993d&scoped=true"
import script from "./HistoryEvent.vue?vue&type=script&lang=js"
export * from "./HistoryEvent.vue?vue&type=script&lang=js"

import "./HistoryEvent.vue?vue&type=style&index=0&id=6304993d&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6304993d"]])

export default __exports__